import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ConsentManagementComponent } from './consent-management/consent-management.component';

@Component({
  selector: 'app-user-account',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ConsentManagementComponent],
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss']
})
export class UserAccountComponent {
}
